import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.Mitgliedschaft.MitgliedschaftGutschein
 * Klasse für die Gutscheine der Mitgliedchaft
 * Endpoints: /api/MitgliedschaftGutschein/pruefen, /api/MitgliedschaftGutschein/nextcode
 */
export class MitgliedschaftGutscheinApi extends BaseApiModel {
	constructor(initialProperties?: Partial<MitgliedschaftGutscheinApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected gutscheinCode: string;
	/**
	 * Description: der Gutscheincode
	 * APIL Type: string
	 */
	get GutscheinCode(): string {
		return this.gutscheinCode;
	}

	/**
	 * Description: der Gutscheincode
	 * APIL Type: string
	 */
	set GutscheinCode(value: string) {
		this.gutscheinCode = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MitgliedschaftGutscheinApi {
		return AppUtils.Helper.createFromMap(dataObject, MitgliedschaftGutscheinApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.GutscheinCode = this.gutscheinCode;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}